<template>
  <div class="second_item">
    <div class="second_item_left">
      <div class="second_item_left_img">
        <img :src="data.data.creator.avatar"/>
      </div>
      <div class="second_item_left_msg">
        <span class="user_name">{{data.data.creator.nickname}}</span>
      </div>
      <div class="second_item_left_comment">{{data.data.title}}</div>
    </div>
    <div class="second_item_oter">
      <div class="second_item_left_time">{{timeToStr(data.createdDate)}}</div>
      <div class="second_item_left_qxCollect" @click="deleteFavorite()">取消收藏</div>
    </div>
    <div class="second_item_right">
      <div class="second_item_right_img">
        <img :src="data.data.images[0]" />
      </div>
    </div>
  </div>
</template>

<script>
import { timeToStr } from '@/assets/js/util'
export default {
  props:{
    data:{
      type:Object,
      default: null
    }
  },
  components: {
  },
  data () {
    return{
      deleteState: false,
      commentState: false,
      comment: '',
    }
  },
  created () {
  },
  methods: {
    deleteFavorite(){
      if(this.data.type = "article"){
        this.$parent.deleteArticle(this.data.data.id)
      }else if(this.data.type = "post"){
        this.$parent.deletePost(this.data.data.id)
      }
    },
    timeToStr(time){
      return timeToStr(time)
    }
  }
}
</script>
<style scoped>
  .second_item{
  width: 770px;
  margin: 0 auto;
  margin-top: 22px;
  padding-bottom: 17px;
  position: relative;
  border-bottom: 1px solid #EBEBEB;
}
.second_item_left{
  position: relative;
  height: 80px;
}
.second_item_left_img{
  width: 55px;
  height: 55px;
  position: absolute;
  top: 10px;
  left: 0px;
}
.second_item_left_img img{
  width: 55px;
  height: 55px;
  border-radius: 50%;
}
.second_item_left_msg{
  font-size: 16px;
  font-weight: 400;
  color: #666666;
  line-height: 16px;
  position: absolute;
  left: 70px;
  top: -7px;
}
.second_item_left_msg .user_name{
  color: #3399CC;
  margin-right: 16px;
}
.second_item_left_time{
  font-size: 14px;
  font-weight: 300;
  color: #666666;
  line-height: 14px;
  position: absolute;
  left: 68px;
}
.second_item_left_reply{
  position: absolute;
  left: 160px;
  font-size: 14px;
  color: #666666;
  line-height: 14px;
  cursor: pointer;
}
.second_item_left_like{
  width: 16px;
  height: 16px;
  position: absolute;
  left: 207px;
  font-size: 14px;
  color: #666666;
  line-height: 16px;
  cursor: pointer;
}
.second_item_left_delete{
  width: 16px;
  height: 16px;
  position: absolute;
  left: 241px;
  font-size: 14px;
  color: #666666;
  line-height: 16px;
  cursor: pointer;
}
.second_item_right{
  position: absolute;
  top: 0px;
  right: 0px;
}
.second_item_right_img{
  width: 80px;
  height: 80px;
}
.second_item_right_img img{
  width: 80px;
  height: 80px;
  background: #DDDDDD;
  border-radius: 10px;
}
.second_item_delete_pop{
  width: 172px;
  height: 77px;
  background: #FFFFFF;
  box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.1);
  border-radius: 5px;
  position: absolute;
  top: 45px;
  left: 213px;
}
.second_item_delete_pop .title{
  font-size: 14px;
  font-weight: 300;
  color: #666666;
  line-height: 14px;
  text-align: center;
  margin-top: 14px;
}
.pop_btn{
  width: 100%;
  margin-top: 14px;
  font-size: 12px;
  font-weight: 300;
  color: #666666;
  text-align: center;
}
.pop_btn_item{
  display: inline-block;
  width: 73px;
  height: 20px;
  line-height: 20px;
  background: #F6F6F6;
  border-radius: 5px;
  margin: 0 auto;
  cursor: pointer;
}
.pop_btn_item:last-child{
  margin-left: 8px;
}
.second_item_left_comment{
  width: 448px;
  font-size: 14px;
  font-weight: 300;
  color: #333333;
  line-height: 24px;
  position: absolute;
  top: 21px;
  left: 70px;
}
.second_item_oter{
  font-size: 14px;
  font-weight: 300;
  color: #666666;
  height: 16px;
  line-height: 16px;
  position: relative;
}
.second_item_left_qxCollect{
  font-size: 14px;
  font-weight: 300;
  color: #666666;
  line-height: 14px;
  position: absolute;
  left: 176px;
  cursor: pointer;
}
</style>